import React from "react";
import { useLocation } from "react-router-dom";

import { AuthLayout, ErrorGlobal, Loader } from "src/components";
import { PATH_LOGIN_ASSOCIATION, VERIFY_CREDENTIALS_PAGE } from "src/constants";
import { TemporaryLogin } from "src/containers/TemporaryLogin";
import { useGetMe } from "src/hooks/useGetMe";
import { useAuthStore } from "src/stores/auth-store";

type Props = {
  children: React.ReactNode;
};

export const GetMeWrapper = ({ children }: Props) => {
  const logout = useAuthStore((state) => state.logout);
  const { data, error } = useGetMe();
  const { pathname } = useLocation();

  if (error) {
    return <ErrorGlobal onLogout={logout} />;
  }

  // @note: if has temporary login but no contact email
  if (
    data?.me.isTemporary &&
    !pathname.includes(PATH_LOGIN_ASSOCIATION) &&
    !pathname.includes(VERIFY_CREDENTIALS_PAGE)
  )
    {return (
      <AuthLayout>
        <TemporaryLogin />
      </AuthLayout>
    );}

  if (!data) {
    return <Loader />;
  }

  return children as React.ReactElement;
};
